// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/org/org_requests.proto (package api.v1.org, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LatLng } from "../../google/type/latlng_pb";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Pagination, PaginationRequest } from "../common/pagination_pb";
import { file_v1_common_pagination } from "../common/pagination_pb";
import type { Category, FollowerProfile, Image, LocationType, OrgPublicProfile, OrgSearchResult, PublicLink, SearchSortBy } from "./org_types_pb";
import { file_v1_org_org_types } from "./org_types_pb";
import { file_v1_image_image_service } from "../image/image_service_pb";
import type { PhysicalAddressData, ServiceAreaData } from "../common/location_pb";
import { file_v1_common_location } from "../common/location_pb";
import type { Event, EventCollaborator, EventCollaboratorRequesteeStatus } from "../event/event_types_pb";
import { file_v1_event_event_types } from "../event/event_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/org/org_requests.proto.
 */
export const file_v1_org_org_requests: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_type_latlng, file_v1_common_common_types, file_v1_common_pagination, file_v1_org_org_types, file_v1_image_image_service, file_v1_common_location, file_v1_event_event_types]);

/**
 * CreateImageRequest is the request to create an image
 *
 * @generated from message api.v1.org.CreateImageRequest
 */
export type CreateImageRequest = Message<"api.v1.org.CreateImageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;
};

/**
 * Describes the message api.v1.org.CreateImageRequest.
 * Use `create(CreateImageRequestSchema)` to create a new message.
 */
export const CreateImageRequestSchema: GenMessage<CreateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 0);

/**
 * CreateRequest is the request to create an organization
 *
 * @generated from message api.v1.org.CreateRequest
 */
export type CreateRequest = Message<"api.v1.org.CreateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Basic Information
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string slug = 4;
   */
  slug: string;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: optional string bio = 6;
   */
  bio?: string;

  /**
   * @generated from field: string category_id = 8;
   */
  categoryId: string;

  /**
   * Contact Information  
   *
   * @generated from field: string email = 10;
   */
  email: string;

  /**
   * @generated from field: string phone = 11;
   */
  phone: string;

  /**
   * @generated from field: optional string website = 12;
   */
  website?: string;

  /**
   * Location Information
   * Location (required) - discriminated union using oneof
   *
   * @generated from oneof api.v1.org.CreateRequest.location_data
   */
  locationData: {
    /**
     * @generated from field: api.v1.common.PhysicalAddressData public_physical_address = 13;
     */
    value: PhysicalAddressData;
    case: "publicPhysicalAddress";
  } | {
    /**
     * @generated from field: api.v1.common.ServiceAreaData public_service_area = 14;
     */
    value: ServiceAreaData;
    case: "publicServiceArea";
  } | { case: undefined; value?: undefined };

  /**
   * Classification
   *
   * @generated from field: string created_by_username = 23;
   */
  createdByUsername: string;

  /**
   * @generated from field: string created_by_email = 24;
   */
  createdByEmail: string;

  /**
   * @generated from field: optional api.v1.org.CreateRequest.OrgAvatarImageUpload avatar_image_upload = 25;
   */
  avatarImageUpload?: CreateRequest_OrgAvatarImageUpload;
};

/**
 * Describes the message api.v1.org.CreateRequest.
 * Use `create(CreateRequestSchema)` to create a new message.
 */
export const CreateRequestSchema: GenMessage<CreateRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 1);

/**
 * Image Upload
 *
 * @generated from message api.v1.org.CreateRequest.OrgAvatarImageUpload
 */
export type CreateRequest_OrgAvatarImageUpload = Message<"api.v1.org.CreateRequest.OrgAvatarImageUpload"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: int32 width = 3;
   */
  width: number;

  /**
   * @generated from field: int32 height = 4;
   */
  height: number;

  /**
   * @generated from field: optional string alt_text = 5;
   */
  altText?: string;
};

/**
 * Describes the message api.v1.org.CreateRequest.OrgAvatarImageUpload.
 * Use `create(CreateRequest_OrgAvatarImageUploadSchema)` to create a new message.
 */
export const CreateRequest_OrgAvatarImageUploadSchema: GenMessage<CreateRequest_OrgAvatarImageUpload> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 1, 0);

/**
 * CreateResponse is the response to create an organization
 *
 * @generated from message api.v1.org.CreateResponse
 */
export type CreateResponse = Message<"api.v1.org.CreateResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.org.CreateResponse.
 * Use `create(CreateResponseSchema)` to create a new message.
 */
export const CreateResponseSchema: GenMessage<CreateResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 2);

/**
 * UpdateRequest is the request to update an organization
 *
 * @generated from message api.v1.org.UpdateRequest
 */
export type UpdateRequest = Message<"api.v1.org.UpdateRequest"> & {
  /**
   * Identifiers
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Basic Information
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: optional string bio = 3;
   */
  bio?: string;

  /**
   * @generated from field: repeated api.v1.org.Image images = 4;
   */
  images: Image[];

  /**
   * Public information 
   *
   * @generated from field: optional string public_phone = 5;
   */
  publicPhone?: string;

  /**
   * @generated from field: optional string public_website = 6;
   */
  publicWebsite?: string;

  /**
   * @generated from field: optional string public_address = 7;
   */
  publicAddress?: string;

  /**
   * @generated from field: optional string public_address_place_id = 8;
   */
  publicAddressPlaceId?: string;

  /**
   * @generated from field: optional double public_address_latitude = 9;
   */
  publicAddressLatitude?: number;

  /**
   * @generated from field: optional double public_address_longitude = 10;
   */
  publicAddressLongitude?: number;

  /**
   * @generated from field: optional string public_address_postal_code = 11;
   */
  publicAddressPostalCode?: string;

  /**
   * @generated from field: optional string public_email = 12;
   */
  publicEmail?: string;

  /**
   * @generated from field: repeated api.v1.org.PublicLink public_links = 13;
   */
  publicLinks: PublicLink[];

  /**
   * Location Information
   *
   * How the organization operates regarding location
   *
   * @generated from field: optional api.v1.org.LocationType location_type = 14;
   */
  locationType?: LocationType;

  /**
   * Description of the service area (for service area type)
   *
   * @generated from field: optional string service_area_description = 15;
   */
  serviceAreaDescription?: string;

  /**
   * Radius in kilometers for service area
   *
   * @generated from field: optional double service_area_radius_km = 16;
   */
  serviceAreaRadiusKm?: number;

  /**
   * Postal code for service area
   *
   * @generated from field: optional string service_area_postal_code = 17;
   */
  serviceAreaPostalCode?: string;

  /**
   * Latitude for service area
   *
   * @generated from field: optional double service_area_latitude = 18;
   */
  serviceAreaLatitude?: number;

  /**
   * Longitude for service area
   *
   * @generated from field: optional double service_area_longitude = 19;
   */
  serviceAreaLongitude?: number;

  /**
   * Place ID for service area
   *
   * @generated from field: optional string service_area_place_id = 20;
   */
  serviceAreaPlaceId?: string;
};

/**
 * Describes the message api.v1.org.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema: GenMessage<UpdateRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 3);

/**
 * UpdateResponse is the response to update an organization
 *
 * @generated from message api.v1.org.UpdateResponse
 */
export type UpdateResponse = Message<"api.v1.org.UpdateResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.org.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema: GenMessage<UpdateResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 4);

/**
 * DeleteRequest is the request to delete an organization
 *
 * @generated from message api.v1.org.DeleteRequest
 */
export type DeleteRequest = Message<"api.v1.org.DeleteRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api.v1.org.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 5);

/**
 * DeleteResponse is the response to delete an organization
 *
 * @generated from message api.v1.org.DeleteResponse
 */
export type DeleteResponse = Message<"api.v1.org.DeleteResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.org.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema: GenMessage<DeleteResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 6);

/**
 * GetRequest is the request to get an organization by slug
 *
 * @generated from message api.v1.org.GetRequest
 */
export type GetRequest = Message<"api.v1.org.GetRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api.v1.org.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 7);

/**
 * GetResponse is the response to get an organization by slug
 *
 * @generated from message api.v1.org.GetResponse
 */
export type GetResponse = Message<"api.v1.org.GetResponse"> & {
  /**
   * @generated from field: api.v1.org.OrgPublicProfile org = 1;
   */
  org?: OrgPublicProfile;

  /**
   * @generated from field: repeated api.v1.org.EventCollaboration collaborations = 2;
   */
  collaborations: EventCollaboration[];
};

/**
 * Describes the message api.v1.org.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 8);

/**
 * @generated from message api.v1.org.EventCollaboration
 */
export type EventCollaboration = Message<"api.v1.org.EventCollaboration"> & {
  /**
   * @generated from field: api.v1.event.Event event = 1;
   */
  event?: Event;

  /**
   * @generated from field: api.v1.event.EventCollaborator collaborator = 2;
   */
  collaborator?: EventCollaborator;
};

/**
 * Describes the message api.v1.org.EventCollaboration.
 * Use `create(EventCollaborationSchema)` to create a new message.
 */
export const EventCollaborationSchema: GenMessage<EventCollaboration> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 9);

/**
 * GetByIdRequest is the request to get an organization by ID
 *
 * @generated from message api.v1.org.GetByIdRequest
 */
export type GetByIdRequest = Message<"api.v1.org.GetByIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.org.GetByIdRequest.
 * Use `create(GetByIdRequestSchema)` to create a new message.
 */
export const GetByIdRequestSchema: GenMessage<GetByIdRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 10);

/**
 * GetByIdResponse is the response to get an organization by ID
 *
 * @generated from message api.v1.org.GetByIdResponse
 */
export type GetByIdResponse = Message<"api.v1.org.GetByIdResponse"> & {
  /**
   * @generated from field: api.v1.org.OrgPublicProfile org = 1;
   */
  org?: OrgPublicProfile;
};

/**
 * Describes the message api.v1.org.GetByIdResponse.
 * Use `create(GetByIdResponseSchema)` to create a new message.
 */
export const GetByIdResponseSchema: GenMessage<GetByIdResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 11);

/**
 * @generated from message api.v1.org.UpdateCollaborationVisibilityRequest
 */
export type UpdateCollaborationVisibilityRequest = Message<"api.v1.org.UpdateCollaborationVisibilityRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string collaborator_id = 2;
   */
  collaboratorId: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesteeStatus requestee_status = 3;
   */
  requesteeStatus: EventCollaboratorRequesteeStatus;
};

/**
 * Describes the message api.v1.org.UpdateCollaborationVisibilityRequest.
 * Use `create(UpdateCollaborationVisibilityRequestSchema)` to create a new message.
 */
export const UpdateCollaborationVisibilityRequestSchema: GenMessage<UpdateCollaborationVisibilityRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 12);

/**
 * @generated from message api.v1.org.UpdateCollaborationVisibilityResponse
 */
export type UpdateCollaborationVisibilityResponse = Message<"api.v1.org.UpdateCollaborationVisibilityResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesteeStatus requestee_status = 2;
   */
  requesteeStatus: EventCollaboratorRequesteeStatus;
};

/**
 * Describes the message api.v1.org.UpdateCollaborationVisibilityResponse.
 * Use `create(UpdateCollaborationVisibilityResponseSchema)` to create a new message.
 */
export const UpdateCollaborationVisibilityResponseSchema: GenMessage<UpdateCollaborationVisibilityResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 13);

/**
 * GetFollowingInfoRequest is the request to get following information
 *
 * @generated from message api.v1.org.GetFollowingInfoRequest
 */
export type GetFollowingInfoRequest = Message<"api.v1.org.GetFollowingInfoRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api.v1.org.GetFollowingInfoRequest.
 * Use `create(GetFollowingInfoRequestSchema)` to create a new message.
 */
export const GetFollowingInfoRequestSchema: GenMessage<GetFollowingInfoRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 14);

/**
 * GetFollowingInfoResponse is the response with following information
 *
 * @generated from message api.v1.org.GetFollowingInfoResponse
 */
export type GetFollowingInfoResponse = Message<"api.v1.org.GetFollowingInfoResponse"> & {
  /**
   * @generated from field: int32 followers_count = 1;
   */
  followersCount: number;

  /**
   * @generated from field: int32 following_count = 2;
   */
  followingCount: number;

  /**
   * @generated from field: bool is_following = 3;
   */
  isFollowing: boolean;
};

/**
 * Describes the message api.v1.org.GetFollowingInfoResponse.
 * Use `create(GetFollowingInfoResponseSchema)` to create a new message.
 */
export const GetFollowingInfoResponseSchema: GenMessage<GetFollowingInfoResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 15);

/**
 * FollowRequest is the request to follow an organization
 *
 * @generated from message api.v1.org.FollowRequest
 */
export type FollowRequest = Message<"api.v1.org.FollowRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message api.v1.org.FollowRequest.
 * Use `create(FollowRequestSchema)` to create a new message.
 */
export const FollowRequestSchema: GenMessage<FollowRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 16);

/**
 * FollowResponse is the response to follow an organization
 *
 * @generated from message api.v1.org.FollowResponse
 */
export type FollowResponse = Message<"api.v1.org.FollowResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.org.FollowResponse.
 * Use `create(FollowResponseSchema)` to create a new message.
 */
export const FollowResponseSchema: GenMessage<FollowResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 17);

/**
 * UnfollowRequest is the request to unfollow an organization
 *
 * @generated from message api.v1.org.UnfollowRequest
 */
export type UnfollowRequest = Message<"api.v1.org.UnfollowRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message api.v1.org.UnfollowRequest.
 * Use `create(UnfollowRequestSchema)` to create a new message.
 */
export const UnfollowRequestSchema: GenMessage<UnfollowRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 18);

/**
 * UnfollowResponse is the response to unfollow an organization
 *
 * @generated from message api.v1.org.UnfollowResponse
 */
export type UnfollowResponse = Message<"api.v1.org.UnfollowResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message api.v1.org.UnfollowResponse.
 * Use `create(UnfollowResponseSchema)` to create a new message.
 */
export const UnfollowResponseSchema: GenMessage<UnfollowResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 19);

/**
 * ListFollowersRequest is the request to list followers
 *
 * @generated from message api.v1.org.ListFollowersRequest
 */
export type ListFollowersRequest = Message<"api.v1.org.ListFollowersRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message api.v1.org.ListFollowersRequest.
 * Use `create(ListFollowersRequestSchema)` to create a new message.
 */
export const ListFollowersRequestSchema: GenMessage<ListFollowersRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 20);

/**
 * ListFollowersResponse is the response with followers list
 *
 * @generated from message api.v1.org.ListFollowersResponse
 */
export type ListFollowersResponse = Message<"api.v1.org.ListFollowersResponse"> & {
  /**
   * @generated from field: repeated api.v1.org.FollowerProfile followers = 1;
   */
  followers: FollowerProfile[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message api.v1.org.ListFollowersResponse.
 * Use `create(ListFollowersResponseSchema)` to create a new message.
 */
export const ListFollowersResponseSchema: GenMessage<ListFollowersResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 21);

/**
 * ListCategoriesResponse is the response with available categories
 *
 * @generated from message api.v1.org.ListCategoriesResponse
 */
export type ListCategoriesResponse = Message<"api.v1.org.ListCategoriesResponse"> & {
  /**
   * @generated from field: repeated api.v1.org.Category categories = 1;
   */
  categories: Category[];
};

/**
 * Describes the message api.v1.org.ListCategoriesResponse.
 * Use `create(ListCategoriesResponseSchema)` to create a new message.
 */
export const ListCategoriesResponseSchema: GenMessage<ListCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 22);

/**
 * Community search parameters for organizations
 *
 * @generated from message api.v1.org.CommunitySearchParams
 */
export type CommunitySearchParams = Message<"api.v1.org.CommunitySearchParams"> & {
  /**
   * @generated from field: google.type.LatLng center_location = 1;
   */
  centerLocation?: LatLng;

  /**
   * @generated from field: int32 radius_km = 2;
   */
  radiusKm: number;
};

/**
 * Describes the message api.v1.org.CommunitySearchParams.
 * Use `create(CommunitySearchParamsSchema)` to create a new message.
 */
export const CommunitySearchParamsSchema: GenMessage<CommunitySearchParams> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 23);

/**
 * Beyond search parameters for organizations
 *
 * Empty for now - could add global filters later like:
 * repeated string country_codes = 1;
 * repeated string region_codes = 2;
 *
 * @generated from message api.v1.org.BeyondSearchParams
 */
export type BeyondSearchParams = Message<"api.v1.org.BeyondSearchParams"> & {
};

/**
 * Describes the message api.v1.org.BeyondSearchParams.
 * Use `create(BeyondSearchParamsSchema)` to create a new message.
 */
export const BeyondSearchParamsSchema: GenMessage<BeyondSearchParams> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 24);

/**
 * Unified SearchOrgsRequest replacing all search/list variants
 *
 * @generated from message api.v1.org.SearchOrgsRequest
 */
export type SearchOrgsRequest = Message<"api.v1.org.SearchOrgsRequest"> & {
  /**
   * Location search mode (required - exactly one)
   *
   * @generated from oneof api.v1.org.SearchOrgsRequest.location_search
   */
  locationSearch: {
    /**
     * @generated from field: api.v1.org.CommunitySearchParams community = 1;
     */
    value: CommunitySearchParams;
    case: "community";
  } | {
    /**
     * @generated from field: api.v1.org.BeyondSearchParams beyond = 2;
     */
    value: BeyondSearchParams;
    case: "beyond";
  } | { case: undefined; value?: undefined };

  /**
   * Search filters (same for both modes)
   *
   * @generated from field: optional string search_query = 3;
   */
  searchQuery?: string;

  /**
   * @generated from field: repeated string category_ids = 4;
   */
  categoryIds: string[];

  /**
   * Sorting and pagination
   *
   * @generated from field: api.v1.org.SearchSortBy sort_by = 5;
   */
  sortBy: SearchSortBy;

  /**
   * @generated from field: bool sort_descending = 6;
   */
  sortDescending: boolean;

  /**
   * @generated from field: api.v1.common.PaginationRequest pagination = 7;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.org.SearchOrgsRequest.
 * Use `create(SearchOrgsRequestSchema)` to create a new message.
 */
export const SearchOrgsRequestSchema: GenMessage<SearchOrgsRequest> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 25);

/**
 * Unified SearchOrgsResponse
 *
 * @generated from message api.v1.org.SearchOrgsResponse
 */
export type SearchOrgsResponse = Message<"api.v1.org.SearchOrgsResponse"> & {
  /**
   * @generated from field: repeated api.v1.org.OrgSearchResult organizations = 1;
   */
  organizations: OrgSearchResult[];

  /**
   * @generated from field: api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * Search context
   *
   * Only for COMMUNITY mode
   *
   * @generated from field: optional google.type.LatLng search_center = 3;
   */
  searchCenter?: LatLng;

  /**
   * Only for COMMUNITY mode
   *
   * @generated from field: optional int32 search_radius_km = 4;
   */
  searchRadiusKm?: number;

  /**
   * @generated from field: int32 total_count = 5;
   */
  totalCount: number;

  /**
   * Result breakdown
   *
   * Orgs with physical addresses
   *
   * @generated from field: int32 physical_address_count = 6;
   */
  physicalAddressCount: number;

  /**
   * Orgs with service areas
   *
   * @generated from field: int32 service_area_count = 7;
   */
  serviceAreaCount: number;

  /**
   * Orgs that serve the search location
   *
   * @generated from field: int32 serves_location_count = 8;
   */
  servesLocationCount: number;
};

/**
 * Describes the message api.v1.org.SearchOrgsResponse.
 * Use `create(SearchOrgsResponseSchema)` to create a new message.
 */
export const SearchOrgsResponseSchema: GenMessage<SearchOrgsResponse> = /*@__PURE__*/
  messageDesc(file_v1_org_org_requests, 26);

